// extracted by mini-css-extract-plugin
module.exports = {"otp":"otp_otp__2mpYb","otp__input":"otp_otp__input__YV_IM","forgot_password_otp_input":"otp_forgot_password_otp_input__28zCH","otp__input_focused":"otp_otp__input_focused__1dmoo"};